export default (axios, path = '/guest') => ({
  findLastAppStatistic: async () => {
    return await axios.get(`${path}/app-stat/last`)
  },
})
